export const paymentAndSettlement = () => {
  return [
    { text: `     9. PAYMENT AND SETTLEMENT.`, bold: true, style: 'p' },

    { text: `     Subject to the provisions of this Section 9, Independent Contractor agrees and acknowledges that payments of and setoffs from any Settlement Payments shall be as follows:`, style: 'p' },

    {
      text: [
        { text: `     9.1.`, bold: true },
        { text: ` Payments for Independent Contractor’s satisfactory completion of each TICA Service hereunder shall be made by the Company in accordance with the flat rate for each shipment offered by Company and accepted by Independent Contractor in accordance with the procedures set forth in Schedule B, attached hereto and made a part hereof;` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     9.2.`, bold: true },
        { text: ` Subject to Section 9.3 below, Independent Contractor expressly agrees and acknowledges that it is the custom and practice of Company to issue Settlement Payments, less authorized setoffs, on the thirtieth (30th) day of the month except when the thirtieth (30th) day falls on a weekend or holiday, whereupon the Settlement Payment shall be sent the next business day, following the month during which Independent Contractor transported Shipments as substantiated by Freight Bills (“Freight Bill(s)”), duly signed by the respective consignee. Independent Contractor expressly waives any right to be paid on any earlier schedule.` }
      ],
      style: 'p',
    },

    { text: `     The Parties agree that because, by delay, Company may lose its ability to recover revenues due Company with respect to each Shipment, signed freight bills or equivalent proof of each TICA Service shall be submitted on a timely basis as provided herein. Company shall issue a Settlement Payment for each completed Shipment on the 30th day of the following month during which Independent Contractor provided TICA Services. Company agrees to include in the monthly Settlement Payment for all Shipments covered by signed Freight Bills postmarked no later than the 3rd day of the calendar month in which the Settlement Payment will be released to Independent Contractor (e.g., payment for TICA Services in the previous month of August and as evidenced by a consignee-signed Freight Bill, postmarked by September 3rd, will be included in the September 30th Settlement Payment). The Settlement Payment will be mailed or deposited (direct deposit) to the Independent Contractor in accordance with the Schedule provided herein, unless the Independent Contractor requests expedited delivery of any Settlement Payment for which Independent Contractor agrees to pay a $15.00 expedited delivery fee for such purposes. Independent Contractor agrees to provide a proof of delivery (POD) within 12 hrs. and mail the original Bill Of Lading (BOL) prior to payment. Failure of Independent Contractor to timely submit a Freight Bill as required shall be considered a breach of the Agreement, and damages incurred by Company may include freight charges related to Shipments for which Freight Bills are not submitted to Company, in which case Independent Contractor shall not receive payment or payment shall be delayed, for any such freight charges. Independent Contractor agrees that Company may deduct from any Settlement Payment a reasonable fee, determined in Company's sole discretion, for Independent Contractor's continued delay in submitting consignee-signed Freight Bills to Company, as provided herein.`, style: 'p' },

    {
      text: [
        { text: `     9.3.`, bold: true },
        { text: ` Independent Contractor further authorizes Company to deduct from any Settlement Payment owed to Independent Contractor for any TICA Services hereunder:` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     9.3.1.`, bold: true },
        { text: ` Any losses or damages incurred by Company for which Independent Contractor agrees to defend, hold harmless, and indemnify Company as provided in Section 12 of this TICA;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     9.3.2.`, bold: true },
        { text: ` Any charges related to products, equipment or services which Independent Contractor elects, in Independent Contractor’s sole discretion, to purchase from or through Company; provided, however, that it is understood that Independent Contractor is not required to purchase any products, equipment or services from or through Company as a condition of entering into this TICA;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     9.3.3.`, bold: true },
        { text: `Any loss or expense incurred by Company as a result of Independent Contractor’s failure to fulfill the requirements of all applicable federal, state and municipal rules and regulations relating to the operation and maintenance of the Equipment covered by this TICA;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     9.3.4.`, bold: true },
        { text: ` Any other cost or expense incurred by Company which is Independent Contractor’s responsibility, in whole or in part, under this TICA; and/or,` }
      ],
      style: 'p',
      margin: [40, 0, 0, 0],
    },

    {
      text: [
        { text: `     9.3.5.`, bold: true },
        { text: ` Any other authorized deduction related to costs or expenses incurred by Independent Contractor in the performance of services under this TICA; and,` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     9.4.`, bold: true },
        { text: ` Independent Contractor agrees that if, within ninety (90) days after receipt of Settlement Payment as herein provided, Independent Contractor does not submit to Company a written objection to the amount or calculation of the Settlement Payment received from Company, each such uncontested Settlement Payment shall be deemed approved and accepted as-is by Independent Contractor.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     9.5.`, bold: true },
        { text: ` Upon termination of this Agreement, Independent Contractor agrees that Company may withhold the sum of One Thousand Five Hundred Dollars ($1,500) ("Holdback Sum") from Independent Contractor’s last Settlement Payment, to be held by Company for not more than sixty (60) days, to ensure payment to Company by Independent Contractor of any obligation or debt outstanding or arising after the last Settlement Payment to Independent Contractor. Assuming that there are no or any partial setoffs against the Holdback Sum, Company shall pay the balance of such Holdback Sum to Independent Contractor no later than five (5) days from such determination.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     9.6.`, bold: true },
        { text: ` In the event that Company and/or any Customer should properly adjust any payment due Company within ninety (90) days of completion of any TICA Service, then Independent Contractor agrees to a corresponding adjustment (“Adjustment”) in any subsequent Settlement Payment otherwise due Independent Contractor to the extent that any such Adjustment is in any way related to any particular Shipment hereunder.` }
      ],
      style: 'p',
    },
  ]
}